var map = {
	"./中小医院网络解决方案.pdf": "7644",
	"./别墅区无线覆盖解决方案.pdf": "9a72",
	"./华为乾坤安全云服务主打胶片.pdf": "ffda",
	"./思科 Mobility Express 解决方案.pdf": "6dd1",
	"./星级酒店网络解决方案.pdf": "6497",
	"./连锁咖啡店无线网络解决方案.pdf": "53b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c7f";